import tinycolor from "tinycolor2";
export const convertToTwoDecimalNumber = (num) => {
    if (typeof num === "string") {
        const number = Number(num);
        return Number(number.toFixed(2));
    }
    return Number(num.toFixed(2));
};
export const colorToHsv = (color) => tinycolor(color).toHsv();
export const colorToHsl = (color) => tinycolor(color).toHsl();
export const colorToRgb = (color) => tinycolor(color).toRgb();
export const colorToHex = (color) => tinycolor(color).toHex();
export const colorToRgbString = (color) => tinycolor(color).toRgbString();
export const colorToHslString = (color) => tinycolor(color).toHslString();
export const colorToHexString = (color) => tinycolor(color).toHexString();
export const colorToPercentage = (color) => tinycolor(color).toPercentageRgb();
export const colorToPercentageString = (color) => tinycolor(color).toPercentageRgbString();
export const colorToName = (color) => tinycolor(color).toName();
//# sourceMappingURL=utils.js.map